import { render, staticRenderFns } from "./DetailedTable.vue?vue&type=template&id=02a5f355&scoped=true&"
import script from "./DetailedTable.vue?vue&type=script&lang=js&"
export * from "./DetailedTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailedTable.vue?vue&type=style&index=0&id=02a5f355&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a5f355",
  null
  
)

export default component.exports